/**
 * KAN-2096 — zákazníkovi říká hned na začátku, že tenhle obchod zatím
 * objednávku nedokončí.
 *
 * Dřív se to dozvěděl až v pokladně („Tento obchod ještě dokončuje
 * nastavení…"), tedy po konfiguraci i košíku. Rozhoduje týž příznak, jaký
 * zavírá pokladnu (``shop_readiness.checkout_ready``), takže proužek a
 * pokladna nemůžou tvrdit každý něco jiného. Proč obchod neprodá (chybí
 * platební metoda, doprava, kurz…), zákazníkovi nepatří — to řeší vlastník
 * v připravenosti.
 *
 * Ukázkový obchod platformy objednávky nezakládá z principu (KAN-35),
 * proto se mu proužek neukazuje.
 */

import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import { useTenantBranding } from "@/api/queries/branding";
import { ShellBanner } from "@/components/ui/ShellBanner";

export function ShopNotOrderableNotice(): JSX.Element | null {
  const { t } = useTranslation("common");
  const branding = useTenantBranding();
  if (!branding.isSuccess || branding.data?.is_platform_demo) return null;
  if (branding.data?.shop_readiness?.checkout_ready !== false) return null;
  return (
    <ShellBanner tone="warn" testId="shop-not-orderable">
      {t("publicTenant.notOrderableBody")}
    </ShellBanner>
  );
}
